import React from 'react'

import { Button } from '@/components/ui/button'
import { useRqCertifiedAssessmentOrFail } from '@/hooks/useRqCertifiedAssessmentQuery'

const ContinueApplicationButtons: React.FC = () => {
  const assessment = useRqCertifiedAssessmentOrFail()

  return (
    <Button asChild className="w-full sm:w-auto">
      <a href={assessment.assessmentUrl} target="_blank" rel="noreferrer">
        Continue application
      </a>
    </Button>
  )
}

export default ContinueApplicationButtons
